import { useEffect } from 'react';
import { FileText, X } from 'lucide-react';

/** Full-screen PDF preview modal */
export default function PdfPreviewModal({ src, title, onClose }) {
    useEffect(() => {
        const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleEsc);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    return (
        <div className="pdf-preview-overlay" onClick={onClose}>
            <div className="pdf-preview-modal" onClick={(e) => e.stopPropagation()}>
                <div className="pdf-preview-header">
                    <FileText size={18} />
                    <span>{title || 'Aperçu du document'}</span>
                    <button className="pdf-preview-close" onClick={onClose}><X size={20} /></button>
                </div>
                <iframe
                    src={src}
                    className="pdf-preview-frame"
                    title={title || 'PDF'}
                />
            </div>
        </div>
    );
}
